<template>
  <!-- SELECTION DU SITE -->
  <v-select
    dense
    v-model="siteTemp"
    :items="listeSites"
    item-text="LIC_URL"
    item-value="LIC_ID"
    :label="$t('select') + ' ' + $tc('sites', 1, {count: ''}) | cap"
    return-object
    @input="updateSite()"
    prepend-icon="language"
    :persistent-hint="hint.trim().length > 0"
    :hint="hint"
    :disabled="disabled"
  ></v-select>
    <!-- autocomplete -->
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    // site: {
    //   type: Object,
    //   required: true
    // },
    hint: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      siteTemp: null,
      listeSites: []
    }
  },

  created () {
    // this.siteTemp = _.clone(this.$store.state._Sites.siteSelected)
    this.listeSites = _.cloneDeep(this.$store.state._Sites.sites)
    this.siteTemp = _.find(this.listeSites, {
      LIC_ID: this.$store.state._Sites.siteSelected.LIC_ID
    })
    this.$emit('update:site', this.siteTemp)
  },

  methods: {
    updateSite () {
      this.$emit('update:site', this.siteTemp)
      this.$store.commit('_Sites/UPDATE_SITE_SELECTED', this.siteTemp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSelectOneSite.vue